import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import {api} from '../lib/api'
import {router} from '../lib/router'

Vue.use(Vuex)

var decodeToken = token => {
	let split = token.split('.')
	return JSON.parse(window.atob(split[1]))
}

export const store = new Vuex.Store({
	state: {
		debug: false,
		token: null,
		user: null,
		tokenReadTime: '',
		loginStatus: '',
		dialogConfirm: {
			open: false,
			title: '',
			message: '',
			btnAcceptText: '',
			btnDenyText: ''
		},
		dialogNotify: {
			open: false,
			title: '',
			message: '',
			duration: 0,
			btnAcceptText: '',
		},
		dialogLoading: {
			open: false
		},
		dialogDone: {
			open: false,
			message: '',
			duration: 1000,
			messageClass: ''
		},
	},
	getters: {
		debug: state => state.debug,
		isAdmin: state => state.user ? state.user.admin : false,
		loggedIn: state => !!state.token,
		loginStatus: state => state.loginStatus,
		tokenReadTime: state => state.tokenReadTime,
		dialogConfirm: state => state.dialogConfirm,
		dialogNotify: state => state.dialogNotify,
		dialogLoading: state => state.dialogLoading,
		dialogDone: state => state.dialogDone,
	},
	mutations: {
		authLoading(state) {
			state.loginStatus = 'loading'
		},
		authSuccess(state, token) {
			if (state.debug) console.log('store mutation - authSuccess')
			state.loginStatus = 'success'
			state.token = token
			state.user = decodeToken(state.token.access).user
			localStorage.setItem('token_access', token.access)
			localStorage.setItem('token_refresh', token.refresh)
			localStorage.setItem('token_exp', token.exp)
			axios.defaults.headers.common['authorization'] = token.access
			axios.defaults.headers.common['x-refresh'] = token.refresh
			router.push('/')
		},
		authLogout(state) {
			if (state.debug) console.log('store mutation - authLogout')

			state.loginStatus = ''
			state.token = null
			state.user = null
			localStorage.removeItem('token_access')
			localStorage.removeItem('token_refresh')
			localStorage.removeItem('token_exp')
			delete axios.defaults.headers.common['authorization']
			delete axios.defaults.headers.common['x-refresh']
			if (router.currentRoute.path != '/login') {
				router.push('/login')
			}
		},
		authFailure(state, error) {
			if (state.debug) console.log('store mutation - authFailure')
			if (state.debug) console.log(error)
			state.loginStatus = 'error'
			state.token = null
			state.user = null
			localStorage.removeItem('token_access')
			localStorage.removeItem('token_refresh')
			localStorage.removeItem('token_exp')
			delete axios.defaults.headers.common['authorization']
			delete axios.defaults.headers.common['x-refresh']
			if (router.currentRoute.path != '/login') {
				router.push('/login')
			}
		},
		updateToken(state, token) {
			if (state.debug) console.log('store mutation - updateToken')
			state.loginStatus = 'success';
			state.token = token;
			state.user = decodeToken(state.token.access).user;
			localStorage.setItem('token_access', token.access);
			localStorage.setItem('token_refresh', token.refresh);
			localStorage.setItem('token_exp', token.exp);
			axios.defaults.headers.common['authorization'] = token.access;
			axios.defaults.headers.common['x-refresh'] = token.refresh;
		},
		getTokenFromStorage(state) {
			if (state.debug) console.log('store mutation - getTokenFromStorage')

			if (localStorage.getItem('token_access')
				&& localStorage.getItem('token_refresh')
				&& localStorage.getItem('token_exp')
			) {
				if (state.debug) console.log('-- token found in localStorage')

				state.token = {
					access: localStorage.getItem('token_access'),
					refresh: localStorage.getItem('token_refresh'),
					exp: localStorage.getItem('token_exp')
				}
				state.tokenReadTime = Math.floor(Date.now() / 1000)
				state.user = decodeToken(state.token.access).user;
				axios.defaults.headers.common['authorization'] = state.token.access;
				axios.defaults.headers.common['x-refresh'] = state.token.refresh;
			}
			else {
				if (state.debug) console.log('-- token not found')

				state.token = null
				state.user = null
				delete axios.defaults.headers.common['authorization']
				delete axios.defaults.headers.common['x-refresh']
			}
		},
		setDialogDone(state, dialog) {
			state.dialogDone = Object.assign(state.dialogDone, dialog)
		},
		setDialogLoading(state, dialog) {
			state.dialogLoading = Object.assign(state.dialogLoading, dialog)
		},
		setDialogNotify(state, dialog) {
			state.dialogNotify = Object.assign(state.dialogNotify, dialog)
		},
		setDialogConfirm(state, dialog) {
			state.dialogConfirm = Object.assign(state.dialogConfirm, dialog)
		},
	},
	actions: {
		retrieveToken(context, credentials) {
			if (context.getters.debug) console.log('store action - retrieveToken')

			return new Promise((resolve, reject) => {
				context.commit('authLoading');

				axios.post(api.path() + 'auth/login', {
					password: credentials.password
				})
				.then(response => {
					if (context.getters.debug) console.log(response)
					if (response.data.success) {
						const token = response.data.token;
						context.commit('authSuccess', token);
					}
					else {
						context.commit('authFailure', response.data.error);
					}

					resolve(response);
				})
				.catch(error => {
					if (context.getters.debug) console.log('-- logout')
					context.commit('authLogout');
					reject(error);
				})
			});
		},
		destroyToken(context) {
			if (context.getters.debug) console.log('store action - destroyToken')

			if (context.getters.loggedIn) {
				return new Promise((resolve, reject) => {

					axios.post(api.path() + 'auth/logout', {
						token: context.state.token.refresh
					})
					.then(response => {

						if (context.getters.debug) console.log('-- logout')
						context.commit('authLogout');
						resolve(response);
					})
					.catch(error => {

						if (context.getters.debug) console.log('-- logout')
						context.commit('authLogout');

						// написать логику для error

						reject(error);
					})
				});
			}
		},
		readToken(context) {
			if (context.getters.debug) console.log('store action - readToken')

			context.commit('getTokenFromStorage')

			if (context.getters.loggedIn) {
				api.post(api.path() + 'auth/check_access')
				.then(response => {
				}, error => {})
			}
		},
		dialogConfirm(context, dialog) {
			dialog.open = true
			dialog.title = dialog.title || ''
			dialog.message = dialog.message || ''
			dialog.btnAcceptText = dialog.btnAcceptText || 'Ок'
			dialog.btnDenyText = dialog.btnDenyText || 'Назад'

			context.commit('setDialogConfirm', dialog)

			return new Promise((resolve, reject) => {
				this.dialogConfirmResolve = resolve
				this.dialogConfirmReject = reject
			})
		},
		dialogConfirmAccept(context) {
			this.dialogConfirmResolve(true)
			context.commit('setDialogConfirm', {
				open: false,
				title: '',
				message: ''
			})
		},
		dialogConfirmDeny(context) {
			this.dialogConfirmResolve(false)
			context.commit('setDialogConfirm', {
				open: false,
				title: '',
				message: ''
			})
		},
		dialogNotify(context, dialog) {
			dialog.open = true
			dialog.title = dialog.title || ''
			dialog.message = dialog.message || ''
			dialog.duration = dialog.duration || 0
			dialog.btnAcceptText = dialog.btnAcceptText || 'Ок'

			context.commit('setDialogNotify', dialog)

			if (dialog.duration > 0) {
				setTimeout(() => {
					this.dispatch('dialogNotifyHide')
				}, dialog.duration)
			}

			return new Promise((resolve, reject) => {
				this.dialogNotifyResolve = resolve
				this.dialogNotifyReject = reject
			})
		},
		dialogNotifyHide(context) {
			this.dialogNotifyResolve(true)
			context.commit('setDialogNotify', {
				open: false,
				title: '',
				message: ''
			})
		},
		dialogDone(context, dialog) {
			dialog = dialog || {}
			dialog.open = true
			dialog.message = dialog.message || ''
			dialog.duration = dialog.duration || 1000
			if (dialog.message.length) {
				dialog.messageClass = 'xs' + Math.min(Math.round((dialog.message.length + 2) / 2.5), 10)
			}

			context.commit('setDialogDone', dialog)

			setTimeout(() => {
				context.commit('setDialogDone', {
					open: false,
					message: '',
					messageClass: ''
				})
			}, dialog.duration)
		},
		dialogLoadingStart(context) {
			context.commit('setDialogLoading', {
				open: true
			})
		},
		dialogLoadingStop(context) {
			context.commit('setDialogLoading', {
				open: false
			})
		},
	}
})
